module.exports = __webpack_public_path__ + "videos/home-53-hero_16x9_en.3bc2811.mp4";